import styled, { css } from 'styled-components';
import { Form } from 'formik';
import { media } from 'src/config/breakpoints';

export const AuthForm = styled(Form)`
  ${media.w.min.px576(css`
    margin: 0 auto;
    max-width: 21.25rem;
  `)};

  ${media.w.min.px992(css`
    margin: 0;
    max-width: 24.375rem;
    padding-left: 3.6vw;
  `)};

  ${media.w.min.px1440(css`
    padding-left: 3.25rem;
  `)};
`;
